// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/campton/CamptonBold.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Campton";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
/* @import url(https://unpkg.com/@webpixels/css@1.1.5/dist/index.css); */

* {
  font-family: "proxima", sans-serif;
}

:root {
  --primary-color: #652B88;
  --secondary-color: #CC7722;
  --grey-color: #E4E4E5;
  --red-color: #ff0000;
  --yellow-color: #E89F23;
  --blue-color: #5D3FD3;
  --green-color: #009E60;
}

.header-item {
  color: #000;
}

.header-item:hover {
  color: #000;
  opacity: 0.8;
}

.navbar-header {
  background: #f0f2f3;
}

body #layout-wrapper .navbar-brand-box,
body #layout-wrapper #sidebar-menu {
  background: #f9f9f9;
}

li.mm-active {
  background: #e89f23;
}

#sidebar-menu ul li a {
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 24px;
  color: #672b88;
}

li.mm-active * {
  background: #e89f23;
}

#sidebar-menu ul li ul.sub-menu li a {
  font-weight: 500;
  font-size: 18px !important;
  line-height: 20px;
  color: #000 !important;
  font-family: "Campton";
}

.simplebar-content,
#sidebar-menu {
  height: 100%;
}

#sidebar-menu > ul > li:not(.mm-active) > a {
  position: relative;
}

#sidebar-menu > ul > li:not(.mm-active) > a:before {
  content: "";
  width: calc(100% - 40px);
  left: 20px;
  position: absolute;
  right: 20px;
  height: 0.5px;
  background: #979797;
  bottom: 0;
}

.table-nowrap th,
.table-nowrap td {
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  color: #e75c25;
  padding: 16px;
  border: 0;
}

.new-actions-cta {
  font-weight: 500;
  font-size: 18px;
  line-height: 22px;
  display: flex;
  align-items: center;
  text-align: right;
  color: #e75c25;
  background: transparent;
  border: oldlace;
  align-self: flex-start;
  float: right;
  font-family: "Campton";
}

.text-right {
  text-align: right;
}

.text-input-label {
  font-size: 20px;
  line-height: 30px;
  color: #000000;
}

.text-input-label-value {
  font-size: 16px;
  line-height: 30px;
}

.image-container {
  align-items: center;
}

.file-upload {
  padding: 0;
  width: max-content;
  position: relative;
  cursor: pointer;
  width: 121px;
}

.file-upload .form-control {
  position: absolute;
  top: 0;
  z-index: 11;
  opacity: 0;
  width: 150px;
}

.file-upload .btn {
  width: 100%;
}

.file-upload:hover {
  opacity: 0.8;
}

.avatar-md {
  height: 80px;
  width: 80px;
  padding: 0;
  margin-right: 30px;
  object-fit: cover;
}

.gray-note {
  background: #f5f5fa;
  border: 1px solid #eeebef;
  border-radius: 4px;
  padding: 16px 20px;
  width: auto;
  font-size: 18px;
  line-height: 20px;
  text-align: center;
  color: #6c6c70;
  display: flex;
  align-items: center;
  max-width: max-content;
}

.gray-note--primary {
  margin-left: 8px;
  font-weight: 500;
  font-size: 24px;
  line-height: 32px;
  text-align: center;
  color: #e75c25;
}

.event-scheduled {
  background-color: #e89f23;
  color: #fff !important;
}

.event-completed {
  background: #fafafa;
  color: #000 !important;
}

.create-link {
  margin-bottom: 20px;
  display: block;
  text-align: right;
  font-size: 18px;
}

.mt-20 {
  margin-top: 20px;
}

.btn-secondary.btn-med {
  background: #e89f23;
  border-radius: 5px;
  border: none;
  margin-right: 20px;
}

.btn-secondary2 {
  background: #e89f23;
  border-radius: 5px;
  border: none;
  color: #fff;
}

.text-input-label--small {
  font-size: 14px;
  line-height: 1;
  text-align: left;
  width: 100%;
}

.pagination-container {
  padding-bottom: 30px;
}

.empty-container {
  max-width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 386px;
  width: 100%;
  margin: 0 auto;
  flex-direction: column;
  text-align: center;
  padding-bottom: 40px;
}

.empty-container h5 {
  color: #e85c25;
  padding-top: 20px;
  margin-left: -30px;
}

.empty-container > div {
  display: flex;
  align-items: center;
}

a.btn.btn-secondary {
  border-color: #e85c25;
  background: #eff2f7;
  color: #e85c25;
}

.cell-tags {
  background: #e89f23;
  border-radius: 8px;
  display: inline-block;
  padding: 2px 6px;
  padding-right: 25px;
  color: #000;
  position: relative;
  margin-right: 10px;
  margin-bottom: 10px;
}

.cell-tag-close {
  appearance: none;
  background: transparent;
  border: none;
  background: #ececec;
  top: -5px;
  position: absolute;
  right: 2px;
  cursor: pointer;
}

.nav-tabs-custom .nav-item {
  max-width: 300px;
  width: 100%;
}

.history-list-item {
  background: #fff;
  border-radius: 8px;
  padding: 24px;
  width: 100%;
  position: relative;
  border-top-left-radius: 0;
}

.history-list-item:before {
  left: -6px;
  position: absolute;
  background: #fff;
  transform: rotate(-45deg);
  content: "";
  width: 20px;
  height: 20px;
  overflow: hidden;
  top: 4px;
}

.history-appointment-details {
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
}

.history-doc-details img {
  width: 0px;
  width: 40px;
  height: 40px;
  border-radius: 100%;
  object-position: center;
  object-fit: cover;
}

.history-doc-details {
  display: flex;
  align-items: center;
}

.history-doc-details p {
  margin: 0;
  margin-left: 10px;
}

.history-doc-cta {
  display: flex;
  justify-content: flex-end;
}

.history-appointment-notes {
  padding-bottom: 20px;
}

.history-doc-cta a,
.history-doc-cta button {
  padding: 10px 16px;
  gap: 4px;
  height: 40px;
  background: #ffffff;
  border: 1px solid #d8d8dc;
  border-radius: 8px;
  flex: none;
  order: 0;
  flex-grow: 0;
  color: #2c2c2e;
}

.history-appointment-type {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: #11142d;
}

.history-appointment-type span {
  display: block;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #8e8e93;
}

.history-appointment-reason {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: #8e8e93;
}

.history-appointment-invoice {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #8e8e93;
}

.history-appointment-invoice span {
  color: #000;
}

.tab-content ul.nav-tabs-custom.nav-justified.nav.nav-tabs a.nav-link {
  font-size: 16px;
  padding: 5px 20px;
}

span.prescription-doc-details-name {
  display: inherit;
}

span.prescription-doc-details-spec {
  opacity: 0.7;
}

.prescription-container {
  background: #ececec;
  
}

@media print {

  .prescription-container {
    background: #fff;
  }
}

.prescription-notes {
  padding: 24px 0;
  background: #ececec;
  max-width: 100%;
  margin-bottom: 24px;
  border-radius: 8px;
}

.prescription-notes strong {
  display: block;
  text-transform: capitalize;
}

.authorized-signatory {
  font-size: 18px;
  padding: 40px 0 40px;
}

.display-name,
.display-name-modal {
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 22px;
  display: flex;
  align-items: center;
  margin-left: 43px;
  color: #672b88;
}

.display-name .display-actual-name,
.display-name-modal .display-actual-name {
  margin-left: 4px;
  color: #e75c25;
}

.display-name-modal {
  display: flex;
  align-items: center;
  margin-left: 0;
  justify-content: center;
}

.has-arrow svg {
  width: 18px;
  margin-right: 20px;
  position: relative;
  top: -2px;
}

.table th:last-child {
  text-align: right;
}

.text-black {
  color: #000;
}

.parent-details__container {
  padding: 24px;
  background: #ffffff;
  border: 1px solid #d8d8dc;
  border-radius: 8px;
}

.parent-details__container .nav-link {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.parent-details__container .nav-link img {
  width: 20px;
  height: 20px;
  border-radius: 10px;
}

.parent-details__container .card-body {
  background: #f5f5fa;
  border-radius: 8px;
}

.parent-details__value {
  font-weight: 500;
  font-size: 18px;
  line-height: 25px;
  color: #11142d;
}

.parent-details__title {
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: #8e8e93;
}

.card-title {
  color: #11142d;
}

.petdetails .avatar-sm {
  background: #fff;
  border-radius: 3px;
  border: 1px solid #ececec;
}

.no-data {
  margin-top: 40px;
  color: #787878;
  margin-left: -10px;
}

textarea {
  resize: none !important;
}

.status-bar {
  position: absolute;
  right: 30px;
  top: 10px;
}

.file-upload-container {
  display: flex;
  flex-wrap: wrap;
}

.file-upload-image {
  width: 80px;
  height: 80px;
  object-fit: cover;
  object-position: center;
  border-radius: 8px;
  border: 1px solid #ececec;
}

.file-upload-image-container {
  margin-right: 10px;
  margin-bottom: 10px;
  width: 80px;
  height: 80px;
  position: relative;
}

.file-upload-image-delete {
  position: absolute;
  background: #e85c25;
  width: 20px;
  height: 20px;
  top: -5px;
  right: -5px;
  cursor: pointer;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.file-upload-square {
  width: 80px;
  height: 80px;
  border: 1px dashed;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 100;
  line-height: 1;
  text-align: center;
  border-radius: 4px;
  margin-right: 10px;
  position: relative;
  margin-bottom: 10px;
}

.file-upload-square input {
  position: absolute;
  top: 0;
  left: 0;
  height: 80px;
  width: 80px;
  opacity: 0;
}

.ReactModal__Overlay {
  z-index: 5000 !important;
}

.dates-container .flatpickr-time input {
  font-weight: bold;
  pointer-events: none;
}

.dates-row .form-check--selected {
  width: 100%;
  padding: 0;
  font-size: 14px;
}

.has-arrow.hide-arrow:after {
  opacity: 0;
}

.video-fullscreen {
  background: #e75c25;
  color: #fff;
  width: 40px;
  height: 40px;
  padding: 0;
  border-radius: 100%;
  border: 0;
  cursor: pointer;
  margin-left: 20px;
}


.hover-container {
  position: relative;
  display: inline-block;
}

.popup {
  visibility: hidden;
  width: 100px;
  background-color: #fff; /* White background */
  color: #333;
  text-align: center;
  border-radius: 6px;
  padding: 8px 0;
  position: absolute;
  z-index: 1000; /* Higher z-index to ensure visibility over the header */
  top: 125%; /* Position below the icon */
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  transition: opacity 0.3s, transform 0.3s ease-in-out;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  font-size: 14px;
}

.hover-container:hover .popup {
  visibility: visible;
  opacity: 1;
  transform: translateX(-50%) translateY(10px);
}

.popup::after {
  content: "";
  position: absolute;
  bottom: 100%; /* Arrow on top */
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent #fff transparent; /* Arrow pointing down */
}

/*dashboard card hover effect*/
.stock-card:hover,
.monthly-revenue-card:hover {
  transform: scale(1.05);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
}

/*defind minimum text length*/
.truncate-text {
  display: inline-block;
  max-width: 120px; /* Set the maximum width as needed */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: "YourFontFamily", sans-serif; /* Replace with your font family */
  font-size: 16px; /* Adjust font size as needed */
  color: #6c757d; /* Replace with your text color */
}

/* Tooltip wrapper */
.tooltip-wrapper {
  position: relative;
  display: inline-block;
  width: 100%; /* Ensure wrapper doesn't shrink */
}

/* Tooltip text */
.custom-tooltip {
  visibility: hidden;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px;
  position: absolute;
  z-index: 1;
  bottom: 125%; /* Position the tooltip above the input */
  left: 50%;
  transform: translateX(-50%);
  width: 160px; /* You can adjust the width */
  opacity: 0;
  transition: opacity 0.3s;
  font-size: 12px;
}

/* Tooltip arrow */
.custom-tooltip::after {
  content: "";
  position: absolute;
  top: 100%; /* Tooltip arrow points down */
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: black transparent transparent transparent;
}

/* Show tooltip when hovering over target */
.tooltip-wrapper:hover .custom-tooltip {
  visibility: visible;
  opacity: 1;
}

/* Tooltip target to ensure AsyncSelect is not modified */
.tooltip-target {
  width: 100%; /* Ensures AsyncSelect keeps its full width */
}

/* Allergercy cell in check in page*/

.cell-tag {
  background-color: #f0f0f0;
  border-radius: 20px;
  padding: 8px 16px;
  display: inline-flex;
  align-items: center;
  justify-content: space-between; /* Ensure spacing between text and icon */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: relative;
  margin: 4px;
}

.cell-tag-close {
  border: none;
  color: white;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  margin-left: 8px;
  margin-top: -3px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  background-color: #ff6b6b !important;
}

.cell-tag-close:hover {
  background-color: #e55b5b;
}

.toolbar-button {
  background-color: #f5f5f5;
  border: 1px solid #ddd;
  padding: 5px 10px;
  margin: 0 5px;
  cursor: pointer;
}

.toolbar-button:hover {
  background-color: #e9e9e9;
}

.toolbar-button.active {
  background-color: #e9e9e9;
  /* color: white; */
  /* border-color: #e9e9e9; */
}

/* .card {
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
}

h5 {
  font-weight: bold;
}

.icon {
  font-size: 2.5rem;
  color: #555;
} */

/* App.css */
.card {
  transition: transform 0.3s, box-shadow 0.3s;
  border-radius: 15px;
  height: 150px;
  cursor: pointer;
}

.dashboard-card {
  height: 93% !important;
}

/* .card:hover {
  transform: translateY(-10px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
} */

.bg-patient {
  background-color: #f9e7e7;
}

.bg-club {
  background-color: #e7f0ff;
}

.bg-revenue {
  background-color: #e7ffe7;
}

.bg-booking {
  background-color: #fff5e7;
}

.bg-pharmacy {
  background-color: #fffbe7;
}

/* .card {
  background-color: #fff;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
  min-height: 200px;
} */
.diffcard {
  background-color: #fff;
  border-radius: 15px;
  padding: 20px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
  /* max-height: 21rem; */
}

/* .diffcard:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.custom-card-shadow {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1); 
  transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
}

.custom-card-shadow:hover {
  transform: translateY(-5px); 
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15), 0 8px 25px rgba(0, 0, 0, 0.15); 
} */

.bg-patient {
  background-color: #f0f9ff;
  border-left: 5px solid #36a2eb;
}

.bg-club {
  background-color: #f9f0ff;
  border-left: 5px solid #8e5ea2;
}

.bg-revenue {
  background-color: #fff0f5;
  border-left: 5px solid #ff6384;
}

.bg-lightblue {
  background-color: #e0f7fa;
}

/* Dashboard Background */
.dashboard-container {
  background-color: #4c84f3;
  min-height: 100vh;
}

/* Card Styles */
.info-card {
  border-radius: 15px;
  background-color: #ffffff;
  padding: 20px;
  transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
}

.info-card:hover {
  transform: scale(1.05);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
}

/* Gradient for the top card */
.bg-gradient {
  background: linear-gradient(90deg, #36d1dc, #5b86e5);
  border-radius: 15px;
}

/* Text and Icon Styles */
.icon-container {
  background-color: #e3f2fd;
  padding: 15px;
  border-radius: 50%;
  display: inline-block;
  margin-bottom: 10px;
}

h1,
h3 {
  color: #333;
}

/* In your App.css or another stylesheet */
.chart-container {
  /* margin: rem; */
  background-color: #f7f7f7; /* Light gray background */

  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Optional: for a subtle shadow */
}

.upcoming-birthdays-card {
  background-color: #ffffff;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.upcoming-birthdays-header {
  padding-bottom: 5px;
  border-bottom: 1px solid #f0f0f0;
  margin-bottom: 15px;
}

.upcoming-birthdays-header h5 {
  margin: 0;
}

.upcoming-birthdays-list .birthday-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #f0f0f0;
}

.birthday-item:last-child {
  border-bottom: none;
}

.birthday-info {
  display: flex;
  align-items: center;
}

.birthday-icon {
  color: orange;
  margin-right: 10px;
}

.send-wishes-btn {
  background-color: transparent;
  border: 1px solid #652b88;
  color: #652b88;
  border-radius: 12px;
  padding: 2px;
  font-size: 14px;
  cursor: pointer;
}

.send-wishes-btn:hover {
  background-color: #652b88;
  color: white;
}

.send-wishes-btn:focus {
  outline: none;
}
.applyBtn {
  background-color: transparent;
  border: 1px solid #652b88;
  background-color: #652b88;
  color: white;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 14px;
  cursor: pointer;
  margin-left: 1rem;
  align-items: center;
}

.chart-card {
  border-radius: 15px;
}

.centered-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.legend {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 15px;
}

.legend-item {
  display: flex;
  align-items: center;
  font-size: 14px;
}

.bullet {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 5px;
}
.appoinment {
  max-height: 495px !important;
  min-height: 300px !important;
}
.doctorSchedual {
  margin-bottom: 5px;
  overflow: scroll;
}

.custom-card {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.custom-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}

.custom-card:hover {
  cursor: pointer;
}

.custom-card {
  border-radius: 12px;
  overflow: hidden;
}

.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.tooltip-wishes {
  visibility: hidden;
  background-color: #333;
  color: #fff;
  text-align: center;
  text-wrap: nowrap;
  padding: 5px;
  border-radius: 5px;
  position: absolute;
  z-index: 1;
  bottom: 25px;
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  transition: opacity 0.3s;
}

.send-wishes-btn:hover .tooltip-wishes {
  visibility: visible;
  opacity: 1;
}

.font-1 { 
  font-size: 1rem;
}

/* OTP Input Container */
.otp-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  margin: 20px;
}

/* Individual OTP Input Box */
/* .otp-input {
  width: 50px;
  height: 50px;
  text-align: center;
  border: 2px solid #ccc;
  border-radius: 5px;
  font-size: 18px;
  color: #333;
  outline: none;
  transition: border-color 0.3s ease-in-out;
} */

.otp-input {
  width: 3rem !important;
  height: 3rem;
  margin: 0 1rem;
  font-size: 2rem;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, .3);
}

.otp-input:focus {
  border-color: #007bff;
  box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
}

/* Separator */
.separator {
  font-size: 20px;
  color: #666;
}


/* Responsive adjustments for smaller screens */
@media (max-width: 768px) {
  .fc-timeGridDay-view .fc-event {
    padding: 4px;
  }

  .fc-event-timings {
    font-size: 0.8rem;
  }

  .fc-timeGrid .fc-timegrid-slot-label {
    font-size: 0.9rem;
  }
}

/*responsive property for dashboard section*/
@media (max-width: 1200px) {
  .card {
    flex-direction: column;
  }
  .badge_hidden {
    display: none;
  }

  .pie-chart-container {
    width: 100%;
    height: 100%;
  }

  .d-flex.align-items-start {
    align-items: flex-start !important;
    text-align: left;
  }

  /* Text Align in Profile update page*/
  /* .alignText {
    text-align: left;
  } */
}

@media (max-width: 768px) {
  /* .pie-chart-container {
    flex-basis: 120px;
    min-width: 120px;
  } */
  .sm-gap {
    gap: 15px;
  }
  .appoinment {
    /* height: 350px !important;
    overflow-y: scroll; */
  }
  .doctorSchedual {
    margin-bottom: 24px;
  }
}

@media (max-width: 576px) {
  .pie-chart-container {
    flex-basis: 100px;
    min-width: 100px;
  }
}

@media print {
  /* Hide page numbers and URLs */
  @page {
    size: auto;
    margin: 0;
  }

  /* Hide default headers and footers */
  body {
    -webkit-print-color-adjust: exact;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/custom.scss","webpack://./src/assets/scss/custom.css"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,4CAAA;ACCF;ADCA,wEAAA;;ACEA;EACE,kCAAkC;ADApC;;ACGA;EDDE,wBAAA;EACE,0BAAA;EACA,qBAAA;ECGJ,oBAAA;EACE,uBAAuB;EDAzB,qBAAA;EACE,sBAAA;ACEF;;ADAA;ECGE,WAAW;AACb;;AAEA;EDDA,WAAA;EACE,YAAA;ACGF;;ADAA;EACE,mBAAA;ACGF;;AAEA;;EAEA,mBAAA;AACA;;AAEA;EACA,mBAAA;AACA;;AAEA;EDHE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;ECKF,cAAA;AACA;;AAEA;EDJE,mBAAA;ACMF;;ADJA;EACE,gBAAA;ECOF,0BAAA;EACE,iBAAiB;EDNnB,sBAAA;EACE,sBAAA;ACQF;;AAEA;;EDLE,YAAA;ACQF;;AAEA;EACE,kBAAkB;ADPpB;;ACUA;EDPE,WAAA;EACA,wBAAA;EACA,UAAA;EACA,kBAAA;EACA,WAAA;ECSF,aAAA;EACE,mBAAmB;EDRrB,SAAA;ACUA;;AAEA;;EDPE,gBAAA;EACA,eAAA;EAEA,iBAAA;EACA,cAAA;EACA,aAAA;EACA,SAAA;ACSF;;AAEA;EACE,gBAAgB;EDPlB,eAAA;EACE,iBAAA;ECSF,aAAA;EACE,mBAAmB;EDPrB,iBAAA;EACE,cAAA;EACA,uBAAA;EACA,eAAA;ECSF,sBAAA;EACE,YAAY;EDRd,sBAAA;ACUA;;AAEA;EACE,iBAAiB;ADRnB;;ACWA;EACE,eAAe;EDRjB,iBAAA;EACE,cAAA;ACUF;;AAEA;EDFE,eAAA;EACA,iBAAA;ACGF;;AAGA;EDZI,mBAAA;ACcJ;;AAEA;EAAA,UAAA;EDRI,kBAAA;ECWJ,kBAAA;EDTE,eAAA;EACE,YAAA;ACWJ;;ADRA;EACE,kBAAA;EACA,MAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;ACYF;;AAEA;EDXA,WAAA;ACaA;;AAEA;EDXE,YAAA;ACaF;;AAEA;EDXE,YAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,iBAAA;ACWF;;AAKA;EDbI,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;ECYJ,eAAA;EAIE,iBAAiB;EDZjB,kBAAA;EACE,cAAA;EACA,aAAA;ECWJ,mBAAA;EDRI,sBAAA;ACcJ;;AAEA;EDXA,gBAAA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;ECUF,cAAA;AAIA;;AAEA;EAFA,yBAAA;EAIE,sBAAsB;ADbxB;;ACgBA;EDbE,mBAAA;EACA,sBAAA;ACYF;;ADVA;EACE,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;ACaF;;ADXA;EACE,gBAAA;ACiBF;;AAEA;EAFA,mBAAA;EAIE,kBAAkB;EDfpB,YAAA;EACE,kBAAA;ACcF;;ADXA;EACE,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;ACiBF;;AAEA;EDfE,eAAA;EACA,cAAA;EACA,gBAAA;ECcF,WAAA;ADbE;;ACmBF;EDhBI,oBAAA;ACeJ;;ADZA;EACE,eAAA;EACA,aAAA;ECeF,mBAAA;EAIE,8BAA8B;EDjBhC,gBAAA;EACE,WAAA;EACA,cAAA;EACA,sBAAA;ECgBF,kBAAA;EAIE,oBAAoB;ADjBtB;;ACoBA;EDjBE,cAAA;EACA,iBAAA;EACA,kBAAA;ACmBF;;AAEA;EDjBE,aAAA;ECgBF,mBAAA;AAIA;;AAEA;EACE,qBDpBA;ECqBA,mBDrBA;EACA,cAAA;ACsBF;;AAEA;EDpBE,mBAAA;EACA,kBAAA;EACA,qBAAA;ECiBF,gBAAA;EAME,mBAAmB;EDpBrB,WAAA;EACE,kBAAA;EACA,kBAAA;ECiBF,mBAAA;AAMA;;AAEA;EDlBE,gBAAA;EACA,uBAAA;EACA,YAAA;ECiBF,mBAAA;EDhBE,SAAA;EACE,kBAAA;EACA,UAAA;EACA,eAAA;ACuBJ;;AAEA;EDrBI,gBAAA;EACA,WAAA;ACuBJ;;AAEA;EDrBA,gBAAA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;ECkBF,kBAAA;EAME,yBAAyB;ADtB3B;;ACyBA;EDtBE,UAAA;EACA,kBAAA;EACA,gBAAA;ECwBA,yBDxBA;EACA,WAAA;ECyBA,WDzBA;ECmBF,YAAA;EAQE,gBAAgB;EDzBlB,QAAA;AC2BA;;AALA;EAQE,aAAa;ED1Bf,8BAAA;EACE,mBAAA;AC4BF;;AAEA;ED3BA,UAAA;EACE,WAAA;EACA,YAAA;ECsBF,mBAAA;EDpBA,uBAAA;ECwBA,iBAAA;AAQA;;AAEA;ED5BE,aAAA;EACA,mBAAA;AC8BF;;AAEA;ED5BE,SAAA;EACA,iBAAA;AC8BF;;AAEA;EANA,aAAA;EAQE,yBAAyB;AD7B3B;;ACgCA;ED7BE,oBAAA;AC+BF;;AALA;;EDtBA,kBAAA;EACE,QAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;ECyBF,QAAA;EAQE,YAAY;ED9Bd,cAAA;ACgCA;;AAEA;ED9BE,kBAAA;EACA,gBAAA;ECyBF,eAAA;EAQE,iBAAiB;ED/BnB,cAAA;ACiCA;;AAEA;ED/BE,cAAA;EACA,kBAAA;EC0BF,gBAAA;EAQE,eAAe;ED/BjB,iBAAA;EACE,cAAA;AC0BF;;ADxBA;EACE,kBAAA;EACA,gBAAA;EC2BF,eAAA;EAQE,iBAAiB;EDhCnB,cAAA;ACkCA;;AAEA;EDjCA,kBAAA;EACE,gBAAA;EC4BF,eAAA;EAQE,iBAAiB;EDjCnB,cAAA;ACmCA;;AAEA;EDlCA,WAAA;ACoCA;;AAEA;EDlCE,eAAA;EACA,iBAAA;AC6BF;;AASA;EDnCI,gBAAA;AC8BJ;;AD1BA;EACE,YAAA;ACoCF;;AAEA;EDnCA,mBAAA;;ACsCA;;AAEA;;EDlCE;IACA,gBAAA;EACA;ACqCF;;ADnCE;ECsCA,eAAe;EDrCb,mBAAA;EACA,eAAA;ECgCJ,mBAAA;EAQE,kBAAkB;ADpCpB;;ACuCA;EDpCE,cAAA;EACA,0BAAA;AC+BF;;AD3BE;EACE,eAAA;EACA,oBAAA;ACqCJ;;AALA;;ED1BA,kBAAA;EACE,gBAAA;EC6BF,eAAA;EAQE,iBAAiB;EDnCnB,aAAA;EACE,mBAAA;EC8BF,iBAAA;EAQE,cAAc;ADnCd;;ACsCF;;EDlCI,gBAAA;EC8BJ,cAAA;AD7BI;;ACuCJ;EDpCM,aAAA;EC+BN,mBAAA;ED9BM,cAAA;EACE,uBAAA;ACuCR;;AALA;ED7BI,WAAA;EACE,kBAAA;EACA,kBAAA;EC+BN,SAAA;AD5BE;;ACsCF;EDnCI,iBAAA;ACqCJ;;ADlCE;EACE,WAAA;ACqCJ;;AAEA;EANA,aAAA;EAQE,mBAAmB;EDnCrB,yBAAA;EACE,kBAAA;AC8BF;;AD5BA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AC+BF;;AD7BA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;ACgCF;;AD9BA;EACE,mBAAA;ECiCF,kBAAA;AAQA;;AAEA;EDvCE,gBAAA;EACA,eAAA;ECkCF,iBAAA;EAQE,cAAc;ADxChB;;AC2CA;EANA,gBAAA;EAQE,eAAe;EDzCjB,iBAAA;EACE,cAAA;AC2CF;;AAEA;ED1CE,cAAA;AC4CF;;AAEA;EARA,gBAAA;EAUE,kBAAkB;ED5CpB,yBAAA;AC8CA;;AAEA;ED5CE,gBAAA;EACA,cAAA;ECqCF,kBAAA;AAUA;;AAEA;ED7CE,uBAAA;AC+CF;;AAEA;ED7CE,kBAAA;EACA,WAAA;EACA,SAAA;AC+CF;;AAEA;EARA,aAAA;EAUE,eAAe;AD9CjB;;ACiDA;ED9CE,WAAA;EACA,YAAA;EAEA,iBAAA;EAEA,uBAAA;EACA,kBAAA;EACA,yBAAA;ACgDF;;AAEA;ED9CE,kBAAA;ECuCF,mBAAA;EAUE,WAAW;ED/Cb,YAAA;EACE,kBAAA;ACiDF;;AAEA;ED/CE,kBAAA;EACA,mBAAA;ECwCF,WAAA;EAUE,YAAY;EDhDd,SAAA;EACE,WAAA;ECyCF,eAAA;EAUE,WAAW;ED/CX,aAAA;EACE,mBAAA;EACA,uBAAA;ACwCJ;;ADpCA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ECuCF,aAAA;EAUE,mBAAmB;ED/CrB,uBAAA;EACE,eAAA;ECwCF,gBAAA;EAUE,cAAc;EDhDhB,kBAAA;EACE,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;ACkDF;;AAEA;EDhDE,kBAAA;EACA,MAAA;ECyCF,OAAA;EAUE,YAAY;EACZ,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,iBAAiB;AACnB;;;AAGA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,sBAAsB,EAAE,qBAAqB;EAC7C,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,aAAa,EAAE,wDAAwD;EACvE,SAAS,EAAE,4BAA4B;EACvC,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,oDAAoD;EACpD,+CAA+C;EAC/C,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY,EAAE,iBAAiB;EAC/B,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,sDAAsD,EAAE,wBAAwB;AAClF;;AAEA,8BAA8B;AAC9B;;EAEE,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA,6BAA6B;AAC7B;EACE,qBAAqB;EACrB,gBAAgB,EAAE,oCAAoC;EACtD,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,yCAAyC,EAAE,kCAAkC;EAC7E,eAAe,EAAE,+BAA+B;EAChD,cAAc,EAAE,iCAAiC;AACnD;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW,EAAE,kCAAkC;AACjD;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY,EAAE,yCAAyC;EACvD,SAAS;EACT,2BAA2B;EAC3B,YAAY,EAAE,6BAA6B;EAC3C,UAAU;EACV,wBAAwB;EACxB,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS,EAAE,8BAA8B;EACzC,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,uDAAuD;AACzD;;AAEA,2CAA2C;AAC3C;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA,yDAAyD;AACzD;EACE,WAAW,EAAE,6CAA6C;AAC5D;;AAEA,oCAAoC;;AAEpC;EACE,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,8BAA8B,EAAE,yCAAyC;EACzE,wCAAwC;EACxC,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;;;;;;;;;;;GAWG;;AAEH,YAAY;AACZ;EACE,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;GAGG;;AAEH;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;;;;GAOG;AACH;EACE,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,mEAAmE;EACnE,uBAAuB;AACzB;;AAEA;;;;;;;;;;;;;GAaG;;AAEH;EACE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,mEAAmE;AACrE;;AAEA;EACE,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA,8BAA8B;AAC9B;EACE,oDAAoD;EACpD,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;AACb;;AAEA,0CAA0C;AAC1C;EACE,iBAAiB;EACjB,yBAAyB,EAAE,0BAA0B;;EAErD,aAAa;EACb,mBAAmB;EACnB,wCAAwC,EAAE,kCAAkC;AAC9E;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;AACA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,4BAA4B;EAC5B,4BAA4B;AAC9B;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA,6BAA6B;AAC7B;;;;;;;;;;GAUG;;AAEH;EACE,sBAAsB;EACtB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA,cAAc;AACd;EACE,eAAe;EACf,WAAW;AACb;;;AAGA,+CAA+C;AAC/C;EACE;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,4CAA4C;AAC5C;EACE;IACE,sBAAsB;EACxB;EACA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kCAAkC;IAClC,gBAAgB;EAClB;;EAEA,qCAAqC;EACrC;;KAEG;AACL;;AAEA;EACE;;;KAGG;EACH;IACE,SAAS;EACX;EACA;IACE;yBACqB;EACvB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,gBAAgB;EAClB;AACF;;AAEA;EACE,+BAA+B;EAC/B;IACE,UAAU;IACV,SAAS;EACX;;EAEA,qCAAqC;EACrC;IACE,iCAAiC;EACnC;AACF","sourcesContent":["@font-face {\n  font-family: \"Campton\";\n  src: url(\"../fonts/campton/CamptonBook.otf\");\n  font-weight: 400;\n}\n\n@font-face {\n  font-family: \"Campton\";\n  src: url(\"../fonts/campton/CamptonMedium.otf\");\n  font-weight: 500;\n}\n\n@font-face {\n  font-family: \"Campton\";\n  src: url(\"../fonts/campton/CamptonBold.otf\");\n  font-weight: 700;\n}\n\n\n.header-item {\n  color: #000;\n\n  &:hover {\n    color: #000;\n    opacity: 0.8;\n  }\n}\n\n.navbar-header {\n  background: #f0f2f3;\n}\n\nbody #layout-wrapper .navbar-brand-box,\nbody #layout-wrapper #sidebar-menu {\n  background: #f9f9f9;\n}\n\nli.mm-active {\n  background: #e89f23;\n}\n\n#sidebar-menu ul li a {\n  font-style: normal;\n  font-weight: 500;\n  font-size: 1.4em;\n  line-height: 36px;\n  color: #672b88;\n}\n\nli.mm-active * {\n  background: #e89f23;\n}\n\n#sidebar-menu ul li ul.sub-menu li a {\n  font-weight: 500;\n  font-size: 18px !important;\n  line-height: 20px;\n  color: #000 !important;\n  font-family: 'Campton';\n}\n\n.simplebar-content,\n#sidebar-menu {\n  height: 100%;\n}\n\n#sidebar-menu>ul>li:not(.mm-active)>a {\n  position: relative;\n}\n\n#sidebar-menu>ul>li:not(.mm-active)>a:before {\n  content: \"\";\n  width: calc(100% - 40px);\n  left: 20px;\n  position: absolute;\n  right: 20px;\n  height: 0.5px;\n  background: #979797;\n  bottom: 0;\n}\n\n.table-nowrap th,\n.table-nowrap td {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 22px;\n  color: #e75c25;\n  padding: 16px;\n  border: 0;\n  text-align: left;\n}\n\n.new-actions-cta {\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 22px;\n  display: flex;\n  align-items: center;\n  text-align: right;\n  // text-decoration-line: underline;\n  color: #e75c25;\n  background: transparent;\n  border: oldlace;\n  align-self: flex-start;\n  float: right;\n  font-family: \"Campton\";\n}\n\n.text-right {\n  text-align: right;\n}\n\n.text-input-label {\n  font-size: 20px;\n  line-height: 30px;\n  color: #000000;\n}\n\n.text-input-label-value {\n  font-size: 16px;\n  line-height: 30px;\n}\n\n.image-container {\n  align-items: center;\n}\n\n.file-upload {\n  padding: 0;\n  width: max-content;\n  position: relative;\n\n  .form-control {\n    position: absolute;\n    top: 0;\n    z-index: 11;\n    opacity: 0;\n    width: 150px;\n  }\n\n  cursor: pointer;\n  width: 121px;\n\n  .btn {\n    width: 100%;\n  }\n\n  &:hover {\n    opacity: 0.8;\n  }\n}\n\n.avatar-md {\n  height: 80px;\n  width: 80px;\n  padding: 0;\n  margin-right: 30px;\n  object-fit: cover;\n}\n\n.gray-note {\n  background: #f5f5fa;\n  border: 1px solid #eeebef;\n  border-radius: 4px;\n  padding: 16px 20px;\n  width: auto;\n  font-size: 18px;\n  line-height: 20px;\n  text-align: center;\n  color: #6c6c70;\n  display: flex;\n  align-items: center;\n  max-width: max-content;\n\n  &--primary {\n    margin-left: 8px;\n    font-weight: 500;\n    font-size: 24px;\n    line-height: 32px;\n    text-align: center;\n    color: #e75c25;\n  }\n}\n\n.event {\n  &-scheduled {\n    background-color: #e89f23;\n    color: #fff !important;\n  }\n\n  &-completed {\n    background: #fafafa;\n    color: #000 !important;\n  }\n}\n\n.create-link {\n  margin-bottom: 20px;\n  display: block;\n  text-align: right;\n  font-size: 18px;\n}\n\n.mt-20 {\n  margin-top: 20px;\n}\n\n.btn-secondary.btn-med {\n  background: #e89f23;\n  border-radius: 5px;\n  border: none;\n  margin-right: 20px;\n}\n\n.btn-secondary2 {\n  background: #e89f23;\n  border-radius: 5px;\n  border: none;\n  color: #fff;\n}\n\n.text-input-label--small {\n  font-size: 14px;\n  line-height: 1;\n  text-align: left;\n  width: 100%;\n}\n\n.pagination-container {\n  padding-bottom: 30px;\n}\n\n.empty-container {\n  max-width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  max-width: 386px;\n  width: 100%;\n  margin: 0 auto;\n  flex-direction: column;\n  text-align: center;\n  padding-bottom: 40px;\n\n  h5 {\n    color: #e85c25;\n    padding-top: 20px;\n    margin-left: -30px;\n  }\n}\n\n.empty-container>div {\n  display: flex;\n  align-items: center;\n}\n\na.btn.btn-secondary {\n  border-color: #e85c25;\n  background: #eff2f7;\n  color: #e85c25;\n}\n\n.cell-tags {\n  background: #e89f23;\n  border-radius: 8px;\n  display: inline-block;\n  padding: 2px 6px;\n  padding-right: 25px;\n  color: #000;\n  position: relative;\n  margin-right: 10px;\n  margin-bottom: 10px;\n}\n\n.cell-tag-close {\n  appearance: none;\n  background: transparent;\n  border: none;\n  background: #ececec;\n  top: -5px;\n  position: absolute;\n  right: 2px;\n  cursor: pointer;\n}\n\n.nav-tabs-custom .nav-item {\n  max-width: 300px;\n  width: 100%;\n}\n\n.history-list-item {\n  background: #F5F5FA;\n  border-radius: 8px;\n  padding: 10px 24px;\n  width: 100%;\n  position: relative;\n  border-top-left-radius: 0;\n\n  &:before {\n    left: -6px;\n    position: absolute;\n    background: #F5F5FA;\n    transform: rotate(-45deg);\n    content: \"\";\n    width: 20px;\n    height: 20px;\n    overflow: hidden;\n    top: 1px;\n  }\n}\n\n.history-appointment-details {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 24px;\n}\n\n.history-doc-details img {\n  width: 0px;\n  width: 40px;\n  height: 40px;\n  border-radius: 100%;\n  object-position: center;\n  object-fit: cover;\n}\n\n.history-doc-details {\n  display: flex;\n  align-items: center;\n}\n\n.history-doc-details p {\n  margin: 0;\n  margin-left: 10px;\n}\n\n.history-doc-cta {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.history-appointment-notes {\n  padding-bottom: 20px;\n}\n\n.history-doc-cta a,\n.history-doc-cta button {\n  padding: 10px 16px;\n  gap: 4px;\n  height: 40px;\n  background: #ffffff;\n  border: 1px solid #d8d8dc;\n  border-radius: 8px;\n  flex: none;\n  order: 0;\n  flex-grow: 0;\n  color: #2c2c2e;\n}\n\n.history-appointment-type {\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 22px;\n  color: #11142d;\n}\n\n.history-appointment-type span {\n  display: block;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: #8e8e93;\n}\n\n.history-appointment-type-1 {\n  display: flex;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  color: #8e8e93;\n  justify-content: space-between;\n  align-items: center;\n  width: \"100%\"; \n  padding: 0;\n  margin: 0;\n}\n\n.history-appointment-reason {\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 20px;\n  color: #8e8e93;\n}\n\n.history-appointment-invoice {\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: #8e8e93;\n}\n\n.history-appointment-invoice span {\n  color: #000;\n}\n\n.tab-content ul.nav-tabs-custom.nav-justified.nav.nav-tabs a.nav-link {\n  font-size: 16px;\n  padding: 5px 20px;\n}\n\nspan.prescription-doc-details-name {\n  display: inherit;\n}\n\nspan.prescription-doc-details-spec {\n  opacity: 0.7;\n}\n\n.prescription-container {\n  background: #ececec;\n\n  @media print {\n    background: #fff;\n  }\n}\n\n.prescription-notes {\n  padding: 24px 0;\n  background: #ececec;\n  max-width: 100%;\n  margin-bottom: 24px;\n  border-radius: 8px;\n\n  strong {\n    display: block;\n    text-transform: capitalize;\n  }\n}\n\n.authorized-signatory {\n  font-size: 18px;\n  padding: 40px 0 40px;\n}\n\n.display-name,\n.display-name-modal {\n  font-style: normal;\n  font-weight: 400;\n  font-size: 20px;\n  line-height: 22px;\n  display: flex;\n  align-items: center;\n  margin-left: 26px;\n  color: #672b88;\n\n  .display-actual-name {\n    margin-left: 4px;\n    color: #e75c25;\n  }\n}\n\n.display-name-modal {\n  display: flex;\n  align-items: center;\n  margin-left: 0;\n  justify-content: center;\n}\n\n.has-arrow {\n  svg {\n    width: 18px;\n    margin-right: 20px;\n    position: relative;\n    top: -2px;\n  }\n}\n\n.table th:last-child {\n  text-align: right;\n}\n\n.text-black {\n  color: #000;\n}\n\n.parent-details {\n  &__container {\n    padding: 24px;\n    background: #ffffff;\n    border: 1px solid #d8d8dc;\n    border-radius: 8px;\n\n    .nav-link {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n\n      img {\n        width: 20px;\n        height: 20px;\n        border-radius: 10px;\n      }\n    }\n\n    .card-body {\n      background: #f5f5fa;\n      border-radius: 8px;\n    }\n  }\n\n  &__value {\n    font-weight: 500;\n    font-size: 18px;\n    line-height: 25px;\n    color: #11142d;\n  }\n\n  &__title {\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 20px;\n    color: #8e8e93;\n  }\n}\n\n.card-title {\n  color: #11142d;\n}\n\n.petdetails .avatar-sm {\n  background: #fff;\n  border-radius: 3px;\n  border: 1px solid #ececec;\n}\n\n.no-data {\n  margin-top: 40px;\n  color: #787878;\n  margin-left: -10px;\n}\n\ntextarea {\n  resize: none !important;\n}\n\n.status-bar {\n  position: absolute;\n  right: 30px;\n  top: 10px;\n}\n\n.file-upload-container {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.file-upload-image {\n  width: 80px;\n  height: 80px;\n  object-fit: cover;\n  object-position: center;\n  border-radius: 8px;\n  border: 1px solid #ececec;\n}\n\n.file-upload-image-container {\n  margin-right: 10px;\n  margin-bottom: 10px;\n  width: 80px;\n  height: 80px;\n  position: relative;\n}\n\n.file-upload-image-delete {\n  position: absolute;\n  background: #e85c25;\n  width: 20px;\n  height: 20px;\n  top: -5px;\n  right: -5px;\n  cursor: pointer;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.file-upload-square {\n  width: 80px;\n  height: 80px;\n  border: 1px dashed;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 11px;\n  font-weight: 100;\n  line-height: 1;\n  text-align: center;\n  border-radius: 4px;\n  margin-right: 10px;\n  position: relative;\n  margin-bottom: 10px;\n}\n\n.file-upload-square input {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 80px;\n  width: 80px;\n  opacity: 0;\n}\n\n.ReactModal__Overlay {\n  z-index: 5000 !important;\n}\n\n.dates-container {\n  .flatpickr-time input {\n    font-weight: bold;\n    pointer-events: none;\n  }\n}\n\n.dates-row .form-check--selected {\n  width: 100%;\n  padding: 0;\n  font-size: 14px;\n}\n\n.has-arrow.hide-arrow:after {\n  opacity: 00;\n}\n\n.video-fullscreen {\n  background: #e75c25;\n  color: #fff;\n  width: 40px;\n  height: 40px;\n  padding: 0;\n  border-radius: 100%;\n  border: 0;\n  cursor: pointer;\n  margin-left: 20px;\n}\n\ndiv.fc-header-toolbar.fc-toolbar.fc-toolbar-ltr {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  // flex-wrap: wrap;\n}\n\nh2#fc-dom-1.fc-toolbar-title {\n  width: 340px;\n  font-family: 'Campton';\n}\n\ndiv.fc-toolbar-chunk {\n  width: 550px;\n  display: flex;\n  align-items: center;\n  gap: \"10px\"\n}\n\n.prescription-letterhead {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 24px;\n  min-height: 118px;\n  padding: 18px 28px;\n  background: #fff;\n  border-bottom: 1px solid #e5e5eb;\n\n  &__details {\n    min-width: 0;\n    flex: 1;\n\n    h2 {\n      color: var(--primary-color);\n      font-size: 24px;\n      line-height: 1.25;\n      overflow-wrap: anywhere;\n    }\n\n    p {\n      color: var(--secondary-color);\n      font-size: 15px;\n      overflow-wrap: anywhere;\n    }\n  }\n\n  &__photo {\n    flex: 0 0 76px;\n    width: 76px;\n    height: 76px;\n    border-radius: 50%;\n    object-fit: cover;\n    background: #f8f8fb;\n  }\n}\n\n.prescription-document-card {\n  border: 0;\n  border-radius: 0;\n  margin-bottom: 0;\n}\n\n.free-consultancy-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  padding: 5px 10px;\n  border: 1px solid #bde7cd;\n  border-radius: 999px;\n  background: #e8f7ee;\n  color: #167440;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.03em;\n  line-height: 1.3;\n  text-transform: uppercase;\n  white-space: nowrap;\n\n  &__dot {\n    display: block;\n    width: 7px;\n    height: 7px;\n    flex: 0 0 7px;\n    border-radius: 50%;\n    background: #218957;\n    align-self: center;\n  }\n}\n\n.appointment-history {\n  &__service-cell {\n    text-align: center;\n  }\n\n  &__service-cell {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n\n  &__table-card {\n    background: #fff;\n    border: 1px solid #e7e8ef;\n    border-radius: 12px;\n    padding: 20px;\n    box-shadow: 0 3px 18px rgba(38, 31, 63, 0.04);\n\n    .react-table table {\n      margin-bottom: 0;\n    }\n\n    .react-table th,\n    .react-table td {\n      vertical-align: middle;\n      padding-top: 14px;\n      padding-bottom: 14px;\n    }\n\n    .react-table th:nth-child(5) {\n      text-align: center;\n    }\n\n    .react-table td {\n      white-space: normal !important;\n      min-width: 100px;\n    }\n  }\n\n  &__toolbar {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    gap: 16px;\n    margin-bottom: 16px;\n  }\n\n  &__controls {\n    gap: 12px;\n    margin-left: 0;\n    margin-right: 0;\n  }\n\n  &__filters-col {\n    flex: 1 1 360px;\n    min-width: 0;\n    padding-left: 0;\n    padding-right: 0;\n  }\n\n  &__filters {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n\n    input {\n      flex: 1 1 200px;\n      min-width: 150px;\n      max-width: 280px;\n    }\n\n    select {\n      flex: 0 1 190px;\n      min-width: 160px;\n    }\n  }\n\n  &__page-size {\n    padding-left: 0;\n    padding-right: 0;\n    margin-left: auto;\n  }\n\n  @media (max-width: 560px) {\n    &__filters {\n      flex-wrap: wrap;\n\n      input, select {\n        max-width: none;\n        flex: 1 1 100%;\n      }\n    }\n  }\n\n  &__muted {\n    color: #7b8191;\n    font-size: 12px;\n    margin-top: 3px;\n  }\n\n  &__status {\n    display: inline-block;\n    padding: 4px 9px;\n    border-radius: 999px;\n    background: #eef0f4;\n    color: #475064;\n    text-transform: capitalize;\n    font-size: 12px;\n    font-weight: 600;\n\n    &--completed { background: #e7f6ec; color: #167440; }\n    &--cancelled { background: #fcebea; color: #b13b35; }\n    &--scheduled, &--rescheduled, &--accepted { background: #fff2db; color: #9a600e; }\n  }\n\n  &__actions {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    flex-wrap: wrap;\n    gap: 8px;\n    min-width: 190px;\n  }\n\n  &__action-button {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n    padding: 7px 10px;\n    border: 1px solid transparent;\n    border-radius: 7px;\n    font-size: 12px;\n    font-weight: 600;\n    line-height: 1.25;\n    white-space: nowrap;\n\n    i { font-size: 16px; line-height: 1; }\n    span { text-decoration: underline; text-underline-offset: 2px; }\n\n    &:hover, &:focus-visible { text-decoration: none; }\n\n    &--details {\n      background: #f2eafa;\n      border-color: #e3d1f0;\n      color: #652b88;\n\n      &:hover, &:focus-visible { background: #e9dcf5; color: #542272; }\n    }\n\n    &--prescription {\n      background: #e8f6ed;\n      border-color: #c8e7d3;\n      color: #167440;\n\n      &:hover, &:focus-visible { background: #d8efdf; color: #105d33; }\n    }\n  }\n}\n\n.appointment-prescription-summary {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding: 18px;\n  border: 1px solid #e7e8ef;\n  border-radius: 10px;\n  background: #fbfbfd;\n  max-width: 780px;\n\n  h6 {\n    font-weight: 700;\n    margin-bottom: 8px;\n  }\n\n  p {\n    overflow-wrap: anywhere;\n  }\n}\n\n@media print {\n  .prescription-letterhead {\n    break-inside: avoid;\n  }\n}\n","@font-face {\n  font-family: \"Campton\";\n  src: url(\"../fonts/campton/CamptonBold.otf\");\n}\n/* @import url(https://unpkg.com/@webpixels/css@1.1.5/dist/index.css); */\n\n* {\n  font-family: \"proxima\", sans-serif;\n}\n\n:root {\n  --primary-color: #652B88;\n  --secondary-color: #CC7722;\n  --grey-color: #E4E4E5;\n  --red-color: #ff0000;\n  --yellow-color: #E89F23;\n  --blue-color: #5D3FD3;\n  --green-color: #009E60;\n}\n\n.header-item {\n  color: #000;\n}\n\n.header-item:hover {\n  color: #000;\n  opacity: 0.8;\n}\n\n.navbar-header {\n  background: #f0f2f3;\n}\n\nbody #layout-wrapper .navbar-brand-box,\nbody #layout-wrapper #sidebar-menu {\n  background: #f9f9f9;\n}\n\nli.mm-active {\n  background: #e89f23;\n}\n\n#sidebar-menu ul li a {\n  font-style: normal;\n  font-weight: 500;\n  font-size: 24px;\n  line-height: 24px;\n  color: #672b88;\n}\n\nli.mm-active * {\n  background: #e89f23;\n}\n\n#sidebar-menu ul li ul.sub-menu li a {\n  font-weight: 500;\n  font-size: 18px !important;\n  line-height: 20px;\n  color: #000 !important;\n  font-family: \"Campton\";\n}\n\n.simplebar-content,\n#sidebar-menu {\n  height: 100%;\n}\n\n#sidebar-menu > ul > li:not(.mm-active) > a {\n  position: relative;\n}\n\n#sidebar-menu > ul > li:not(.mm-active) > a:before {\n  content: \"\";\n  width: calc(100% - 40px);\n  left: 20px;\n  position: absolute;\n  right: 20px;\n  height: 0.5px;\n  background: #979797;\n  bottom: 0;\n}\n\n.table-nowrap th,\n.table-nowrap td {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 22px;\n  color: #e75c25;\n  padding: 16px;\n  border: 0;\n}\n\n.new-actions-cta {\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 22px;\n  display: flex;\n  align-items: center;\n  text-align: right;\n  color: #e75c25;\n  background: transparent;\n  border: oldlace;\n  align-self: flex-start;\n  float: right;\n  font-family: \"Campton\";\n}\n\n.text-right {\n  text-align: right;\n}\n\n.text-input-label {\n  font-size: 20px;\n  line-height: 30px;\n  color: #000000;\n}\n\n.text-input-label-value {\n  font-size: 16px;\n  line-height: 30px;\n}\n\n.image-container {\n  align-items: center;\n}\n\n.file-upload {\n  padding: 0;\n  width: -moz-max-content;\n  width: max-content;\n  position: relative;\n  cursor: pointer;\n  width: 121px;\n}\n\n.file-upload .form-control {\n  position: absolute;\n  top: 0;\n  z-index: 11;\n  opacity: 0;\n  width: 150px;\n}\n\n.file-upload .btn {\n  width: 100%;\n}\n\n.file-upload:hover {\n  opacity: 0.8;\n}\n\n.avatar-md {\n  height: 80px;\n  width: 80px;\n  padding: 0;\n  margin-right: 30px;\n  -o-object-fit: cover;\n  object-fit: cover;\n}\n\n.gray-note {\n  background: #f5f5fa;\n  border: 1px solid #eeebef;\n  border-radius: 4px;\n  padding: 16px 20px;\n  width: auto;\n  font-size: 18px;\n  line-height: 20px;\n  text-align: center;\n  color: #6c6c70;\n  display: flex;\n  align-items: center;\n  max-width: -moz-max-content;\n  max-width: max-content;\n}\n\n.gray-note--primary {\n  margin-left: 8px;\n  font-weight: 500;\n  font-size: 24px;\n  line-height: 32px;\n  text-align: center;\n  color: #e75c25;\n}\n\n.event-scheduled {\n  background-color: #e89f23;\n  color: #fff !important;\n}\n\n.event-completed {\n  background: #fafafa;\n  color: #000 !important;\n}\n\n.create-link {\n  margin-bottom: 20px;\n  display: block;\n  text-align: right;\n  font-size: 18px;\n}\n\n.mt-20 {\n  margin-top: 20px;\n}\n\n.btn-secondary.btn-med {\n  background: #e89f23;\n  border-radius: 5px;\n  border: none;\n  margin-right: 20px;\n}\n\n.btn-secondary2 {\n  background: #e89f23;\n  border-radius: 5px;\n  border: none;\n  color: #fff;\n}\n\n.text-input-label--small {\n  font-size: 14px;\n  line-height: 1;\n  text-align: left;\n  width: 100%;\n}\n\n.pagination-container {\n  padding-bottom: 30px;\n}\n\n.empty-container {\n  max-width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  max-width: 386px;\n  width: 100%;\n  margin: 0 auto;\n  flex-direction: column;\n  text-align: center;\n  padding-bottom: 40px;\n}\n\n.empty-container h5 {\n  color: #e85c25;\n  padding-top: 20px;\n  margin-left: -30px;\n}\n\n.empty-container > div {\n  display: flex;\n  align-items: center;\n}\n\na.btn.btn-secondary {\n  border-color: #e85c25;\n  background: #eff2f7;\n  color: #e85c25;\n}\n\n.cell-tags {\n  background: #e89f23;\n  border-radius: 8px;\n  display: inline-block;\n  padding: 2px 6px;\n  padding-right: 25px;\n  color: #000;\n  position: relative;\n  margin-right: 10px;\n  margin-bottom: 10px;\n}\n\n.cell-tag-close {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background: transparent;\n  border: none;\n  background: #ececec;\n  top: -5px;\n  position: absolute;\n  right: 2px;\n  cursor: pointer;\n}\n\n.nav-tabs-custom .nav-item {\n  max-width: 300px;\n  width: 100%;\n}\n\n.history-list-item {\n  background: #fff;\n  border-radius: 8px;\n  padding: 24px;\n  width: 100%;\n  position: relative;\n  border-top-left-radius: 0;\n}\n\n.history-list-item:before {\n  left: -6px;\n  position: absolute;\n  background: #fff;\n  transform: rotate(-45deg);\n  content: \"\";\n  width: 20px;\n  height: 20px;\n  overflow: hidden;\n  top: 4px;\n}\n\n.history-appointment-details {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 24px;\n}\n\n.history-doc-details img {\n  width: 0px;\n  width: 40px;\n  height: 40px;\n  border-radius: 100%;\n  -o-object-position: center;\n  object-position: center;\n  -o-object-fit: cover;\n  object-fit: cover;\n}\n\n.history-doc-details {\n  display: flex;\n  align-items: center;\n}\n\n.history-doc-details p {\n  margin: 0;\n  margin-left: 10px;\n}\n\n.history-doc-cta {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.history-appointment-notes {\n  padding-bottom: 20px;\n}\n\n.history-doc-cta a,\n.history-doc-cta button {\n  padding: 10px 16px;\n  gap: 4px;\n  height: 40px;\n  background: #ffffff;\n  border: 1px solid #d8d8dc;\n  border-radius: 8px;\n  flex: none;\n  order: 0;\n  flex-grow: 0;\n  color: #2c2c2e;\n}\n\n.history-appointment-type {\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 22px;\n  color: #11142d;\n}\n\n.history-appointment-type span {\n  display: block;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: #8e8e93;\n}\n\n.history-appointment-reason {\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 20px;\n  color: #8e8e93;\n}\n\n.history-appointment-invoice {\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: #8e8e93;\n}\n\n.history-appointment-invoice span {\n  color: #000;\n}\n\n.tab-content ul.nav-tabs-custom.nav-justified.nav.nav-tabs a.nav-link {\n  font-size: 16px;\n  padding: 5px 20px;\n}\n\nspan.prescription-doc-details-name {\n  display: inherit;\n}\n\nspan.prescription-doc-details-spec {\n  opacity: 0.7;\n}\n\n.prescription-container {\n  background: #ececec;\n  \n}\n\n@media print {\n\n  .prescription-container {\n    background: #fff;\n  }\n}\n\n.prescription-notes {\n  padding: 24px 0;\n  background: #ececec;\n  max-width: 100%;\n  margin-bottom: 24px;\n  border-radius: 8px;\n}\n\n.prescription-notes strong {\n  display: block;\n  text-transform: capitalize;\n}\n\n.authorized-signatory {\n  font-size: 18px;\n  padding: 40px 0 40px;\n}\n\n.display-name,\n.display-name-modal {\n  font-style: normal;\n  font-weight: 400;\n  font-size: 20px;\n  line-height: 22px;\n  display: flex;\n  align-items: center;\n  margin-left: 43px;\n  color: #672b88;\n}\n\n.display-name .display-actual-name,\n.display-name-modal .display-actual-name {\n  margin-left: 4px;\n  color: #e75c25;\n}\n\n.display-name-modal {\n  display: flex;\n  align-items: center;\n  margin-left: 0;\n  justify-content: center;\n}\n\n.has-arrow svg {\n  width: 18px;\n  margin-right: 20px;\n  position: relative;\n  top: -2px;\n}\n\n.table th:last-child {\n  text-align: right;\n}\n\n.text-black {\n  color: #000;\n}\n\n.parent-details__container {\n  padding: 24px;\n  background: #ffffff;\n  border: 1px solid #d8d8dc;\n  border-radius: 8px;\n}\n\n.parent-details__container .nav-link {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.parent-details__container .nav-link img {\n  width: 20px;\n  height: 20px;\n  border-radius: 10px;\n}\n\n.parent-details__container .card-body {\n  background: #f5f5fa;\n  border-radius: 8px;\n}\n\n.parent-details__value {\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 25px;\n  color: #11142d;\n}\n\n.parent-details__title {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 20px;\n  color: #8e8e93;\n}\n\n.card-title {\n  color: #11142d;\n}\n\n.petdetails .avatar-sm {\n  background: #fff;\n  border-radius: 3px;\n  border: 1px solid #ececec;\n}\n\n.no-data {\n  margin-top: 40px;\n  color: #787878;\n  margin-left: -10px;\n}\n\ntextarea {\n  resize: none !important;\n}\n\n.status-bar {\n  position: absolute;\n  right: 30px;\n  top: 10px;\n}\n\n.file-upload-container {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.file-upload-image {\n  width: 80px;\n  height: 80px;\n  -o-object-fit: cover;\n  object-fit: cover;\n  -o-object-position: center;\n  object-position: center;\n  border-radius: 8px;\n  border: 1px solid #ececec;\n}\n\n.file-upload-image-container {\n  margin-right: 10px;\n  margin-bottom: 10px;\n  width: 80px;\n  height: 80px;\n  position: relative;\n}\n\n.file-upload-image-delete {\n  position: absolute;\n  background: #e85c25;\n  width: 20px;\n  height: 20px;\n  top: -5px;\n  right: -5px;\n  cursor: pointer;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.file-upload-square {\n  width: 80px;\n  height: 80px;\n  border: 1px dashed;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 11px;\n  font-weight: 100;\n  line-height: 1;\n  text-align: center;\n  border-radius: 4px;\n  margin-right: 10px;\n  position: relative;\n  margin-bottom: 10px;\n}\n\n.file-upload-square input {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 80px;\n  width: 80px;\n  opacity: 0;\n}\n\n.ReactModal__Overlay {\n  z-index: 5000 !important;\n}\n\n.dates-container .flatpickr-time input {\n  font-weight: bold;\n  pointer-events: none;\n}\n\n.dates-row .form-check--selected {\n  width: 100%;\n  padding: 0;\n  font-size: 14px;\n}\n\n.has-arrow.hide-arrow:after {\n  opacity: 0;\n}\n\n.video-fullscreen {\n  background: #e75c25;\n  color: #fff;\n  width: 40px;\n  height: 40px;\n  padding: 0;\n  border-radius: 100%;\n  border: 0;\n  cursor: pointer;\n  margin-left: 20px;\n}\n\n/*# sourceMappingURL=custom.css.map */\n\n.hover-container {\n  position: relative;\n  display: inline-block;\n}\n\n.popup {\n  visibility: hidden;\n  width: 100px;\n  background-color: #fff; /* White background */\n  color: #333;\n  text-align: center;\n  border-radius: 6px;\n  padding: 8px 0;\n  position: absolute;\n  z-index: 1000; /* Higher z-index to ensure visibility over the header */\n  top: 125%; /* Position below the icon */\n  left: 50%;\n  transform: translateX(-50%);\n  opacity: 0;\n  transition: opacity 0.3s, transform 0.3s ease-in-out;\n  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);\n  font-size: 14px;\n}\n\n.hover-container:hover .popup {\n  visibility: visible;\n  opacity: 1;\n  transform: translateX(-50%) translateY(10px);\n}\n\n.popup::after {\n  content: \"\";\n  position: absolute;\n  bottom: 100%; /* Arrow on top */\n  left: 50%;\n  margin-left: -5px;\n  border-width: 5px;\n  border-style: solid;\n  border-color: transparent transparent #fff transparent; /* Arrow pointing down */\n}\n\n/*dashboard card hover effect*/\n.stock-card:hover,\n.monthly-revenue-card:hover {\n  transform: scale(1.05);\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);\n}\n\n/*defind minimum text length*/\n.truncate-text {\n  display: inline-block;\n  max-width: 120px; /* Set the maximum width as needed */\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-family: \"YourFontFamily\", sans-serif; /* Replace with your font family */\n  font-size: 16px; /* Adjust font size as needed */\n  color: #6c757d; /* Replace with your text color */\n}\n\n/* Tooltip wrapper */\n.tooltip-wrapper {\n  position: relative;\n  display: inline-block;\n  width: 100%; /* Ensure wrapper doesn't shrink */\n}\n\n/* Tooltip text */\n.custom-tooltip {\n  visibility: hidden;\n  background-color: black;\n  color: #fff;\n  text-align: center;\n  border-radius: 6px;\n  padding: 5px;\n  position: absolute;\n  z-index: 1;\n  bottom: 125%; /* Position the tooltip above the input */\n  left: 50%;\n  transform: translateX(-50%);\n  width: 160px; /* You can adjust the width */\n  opacity: 0;\n  transition: opacity 0.3s;\n  font-size: 12px;\n}\n\n/* Tooltip arrow */\n.custom-tooltip::after {\n  content: \"\";\n  position: absolute;\n  top: 100%; /* Tooltip arrow points down */\n  left: 50%;\n  margin-left: -5px;\n  border-width: 5px;\n  border-style: solid;\n  border-color: black transparent transparent transparent;\n}\n\n/* Show tooltip when hovering over target */\n.tooltip-wrapper:hover .custom-tooltip {\n  visibility: visible;\n  opacity: 1;\n}\n\n/* Tooltip target to ensure AsyncSelect is not modified */\n.tooltip-target {\n  width: 100%; /* Ensures AsyncSelect keeps its full width */\n}\n\n/* Allergercy cell in check in page*/\n\n.cell-tag {\n  background-color: #f0f0f0;\n  border-radius: 20px;\n  padding: 8px 16px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: space-between; /* Ensure spacing between text and icon */\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  position: relative;\n  margin: 4px;\n}\n\n.cell-tag-close {\n  border: none;\n  color: white;\n  border-radius: 50%;\n  width: 20px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  margin-left: 8px;\n  margin-top: -3px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  background-color: #ff6b6b !important;\n}\n\n.cell-tag-close:hover {\n  background-color: #e55b5b;\n}\n\n.toolbar-button {\n  background-color: #f5f5f5;\n  border: 1px solid #ddd;\n  padding: 5px 10px;\n  margin: 0 5px;\n  cursor: pointer;\n}\n\n.toolbar-button:hover {\n  background-color: #e9e9e9;\n}\n\n.toolbar-button.active {\n  background-color: #e9e9e9;\n  /* color: white; */\n  /* border-color: #e9e9e9; */\n}\n\n/* .card {\n  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);\n}\n\nh5 {\n  font-weight: bold;\n}\n\n.icon {\n  font-size: 2.5rem;\n  color: #555;\n} */\n\n/* App.css */\n.card {\n  transition: transform 0.3s, box-shadow 0.3s;\n  border-radius: 15px;\n  height: 150px;\n  cursor: pointer;\n}\n\n.dashboard-card {\n  height: 93% !important;\n}\n\n/* .card:hover {\n  transform: translateY(-10px);\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);\n} */\n\n.bg-patient {\n  background-color: #f9e7e7;\n}\n\n.bg-club {\n  background-color: #e7f0ff;\n}\n\n.bg-revenue {\n  background-color: #e7ffe7;\n}\n\n.bg-booking {\n  background-color: #fff5e7;\n}\n\n.bg-pharmacy {\n  background-color: #fffbe7;\n}\n\n/* .card {\n  background-color: #fff;\n  border-radius: 12px;\n  padding: 20px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;\n  min-height: 200px;\n} */\n.diffcard {\n  background-color: #fff;\n  border-radius: 15px;\n  padding: 20px;\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\n  transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;\n  /* max-height: 21rem; */\n}\n\n/* .diffcard:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);\n}\n\n.custom-card-shadow {\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1); \n  transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;\n}\n\n.custom-card-shadow:hover {\n  transform: translateY(-5px); \n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15), 0 8px 25px rgba(0, 0, 0, 0.15); \n} */\n\n.bg-patient {\n  background-color: #f0f9ff;\n  border-left: 5px solid #36a2eb;\n}\n\n.bg-club {\n  background-color: #f9f0ff;\n  border-left: 5px solid #8e5ea2;\n}\n\n.bg-revenue {\n  background-color: #fff0f5;\n  border-left: 5px solid #ff6384;\n}\n\n.bg-lightblue {\n  background-color: #e0f7fa;\n}\n\n/* Dashboard Background */\n.dashboard-container {\n  background-color: #4c84f3;\n  min-height: 100vh;\n}\n\n/* Card Styles */\n.info-card {\n  border-radius: 15px;\n  background-color: #ffffff;\n  padding: 20px;\n  transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;\n}\n\n.info-card:hover {\n  transform: scale(1.05);\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);\n}\n\n/* Gradient for the top card */\n.bg-gradient {\n  background: linear-gradient(90deg, #36d1dc, #5b86e5);\n  border-radius: 15px;\n}\n\n/* Text and Icon Styles */\n.icon-container {\n  background-color: #e3f2fd;\n  padding: 15px;\n  border-radius: 50%;\n  display: inline-block;\n  margin-bottom: 10px;\n}\n\nh1,\nh3 {\n  color: #333;\n}\n\n/* In your App.css or another stylesheet */\n.chart-container {\n  /* margin: rem; */\n  background-color: #f7f7f7; /* Light gray background */\n\n  padding: 20px;\n  border-radius: 10px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Optional: for a subtle shadow */\n}\n\n.upcoming-birthdays-card {\n  background-color: #ffffff;\n  padding: 20px;\n  border-radius: 12px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.upcoming-birthdays-header {\n  padding-bottom: 5px;\n  border-bottom: 1px solid #f0f0f0;\n  margin-bottom: 15px;\n}\n\n.upcoming-birthdays-header h5 {\n  margin: 0;\n}\n\n.upcoming-birthdays-list .birthday-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 0;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.birthday-item:last-child {\n  border-bottom: none;\n}\n\n.birthday-info {\n  display: flex;\n  align-items: center;\n}\n\n.birthday-icon {\n  color: orange;\n  margin-right: 10px;\n}\n\n.send-wishes-btn {\n  background-color: transparent;\n  border: 1px solid #652b88;\n  color: #652b88;\n  border-radius: 12px;\n  padding: 2px;\n  font-size: 14px;\n  cursor: pointer;\n}\n\n.send-wishes-btn:hover {\n  background-color: #652b88;\n  color: white;\n}\n\n.send-wishes-btn:focus {\n  outline: none;\n}\n.applyBtn {\n  background-color: transparent;\n  border: 1px solid #652b88;\n  background-color: #652b88;\n  color: white;\n  border-radius: 8px;\n  padding: 10px 12px;\n  font-size: 14px;\n  cursor: pointer;\n  margin-left: 1rem;\n  align-items: center;\n}\n\n.chart-card {\n  border-radius: 15px;\n}\n\n.centered-text {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  text-align: center;\n}\n\n.legend {\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n  margin-top: 15px;\n}\n\n.legend-item {\n  display: flex;\n  align-items: center;\n  font-size: 14px;\n}\n\n.bullet {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  margin-right: 5px;\n}\n.appoinment {\n  max-height: 495px !important;\n  min-height: 300px !important;\n}\n.doctorSchedual {\n  margin-bottom: 5px;\n  overflow: scroll;\n}\n\n.custom-card {\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.custom-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);\n}\n\n.custom-card:hover {\n  cursor: pointer;\n}\n\n.custom-card {\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.flex-center {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.tooltip-wishes {\n  visibility: hidden;\n  background-color: #333;\n  color: #fff;\n  text-align: center;\n  text-wrap: nowrap;\n  padding: 5px;\n  border-radius: 5px;\n  position: absolute;\n  z-index: 1;\n  bottom: 25px;\n  left: 50%;\n  transform: translateX(-50%);\n  opacity: 0;\n  transition: opacity 0.3s;\n}\n\n.send-wishes-btn:hover .tooltip-wishes {\n  visibility: visible;\n  opacity: 1;\n}\n\n.font-1 { \n  font-size: 1rem;\n}\n\n/* OTP Input Container */\n.otp-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  margin: 20px;\n}\n\n/* Individual OTP Input Box */\n/* .otp-input {\n  width: 50px;\n  height: 50px;\n  text-align: center;\n  border: 2px solid #ccc;\n  border-radius: 5px;\n  font-size: 18px;\n  color: #333;\n  outline: none;\n  transition: border-color 0.3s ease-in-out;\n} */\n\n.otp-input {\n  width: 3rem !important;\n  height: 3rem;\n  margin: 0 1rem;\n  font-size: 2rem;\n  border-radius: 4px;\n  border: 1px solid rgba(0, 0, 0, .3);\n}\n\n.otp-input:focus {\n  border-color: #007bff;\n  box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);\n}\n\n/* Separator */\n.separator {\n  font-size: 20px;\n  color: #666;\n}\n\n\n/* Responsive adjustments for smaller screens */\n@media (max-width: 768px) {\n  .fc-timeGridDay-view .fc-event {\n    padding: 4px;\n  }\n\n  .fc-event-timings {\n    font-size: 0.8rem;\n  }\n\n  .fc-timeGrid .fc-timegrid-slot-label {\n    font-size: 0.9rem;\n  }\n}\n\n/*responsive property for dashboard section*/\n@media (max-width: 1200px) {\n  .card {\n    flex-direction: column;\n  }\n  .badge_hidden {\n    display: none;\n  }\n\n  .pie-chart-container {\n    width: 100%;\n    height: 100%;\n  }\n\n  .d-flex.align-items-start {\n    align-items: flex-start !important;\n    text-align: left;\n  }\n\n  /* Text Align in Profile update page*/\n  /* .alignText {\n    text-align: left;\n  } */\n}\n\n@media (max-width: 768px) {\n  /* .pie-chart-container {\n    flex-basis: 120px;\n    min-width: 120px;\n  } */\n  .sm-gap {\n    gap: 15px;\n  }\n  .appoinment {\n    /* height: 350px !important;\n    overflow-y: scroll; */\n  }\n  .doctorSchedual {\n    margin-bottom: 24px;\n  }\n}\n\n@media (max-width: 576px) {\n  .pie-chart-container {\n    flex-basis: 100px;\n    min-width: 100px;\n  }\n}\n\n@media print {\n  /* Hide page numbers and URLs */\n  @page {\n    size: auto;\n    margin: 0;\n  }\n\n  /* Hide default headers and footers */\n  body {\n    -webkit-print-color-adjust: exact;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
